export default {
    path: '/resource',
    name: 'resource',
    component: () => import('../../views/Layout/index'),
    meta: {
      title: '资源',
      // keepAlive: false
    },
    children: [
      {
        // 资源-产品管理
        path: 'productManage/productList',
        name: 'productList',
        component: () => import('../../views/Resource/ProductManage/ProductList/ProductList'),
        meta: { title: '产品管理', keepAlive: false }
      },
      {
        // 资源-产品管理-添加产品
        path: 'productManage/productAdd',
        name: 'productAdd',
        component: () => import('../../views/Resource/ProductManage/ProductAdd/ProductAdd'),
        meta: { title: '添加产品', keepAlive: false }
      },
      {
        // 重定向
        path: 'productManage/redirect',
        name: 'Redirect',
        component: () => import('../../components/KindEditor/Redirect'),
        meta: { title: '重定向', keepAlive: false }
      },
      {
        // 资源-产品管理-编辑产品
        path: 'productManage/productEdit',
        name: 'productEdit',
        component: () => import('../../views/Resource/ProductManage/ProductAdd/ProductAdd'),
        meta: { title: '编辑产品', keepAlive: false }
      },
      {
        // 资源-号卡管理-号码池
        path: 'numCardManage/numPool',
        name: 'numPool',
        component: () => import('../../views/Resource/NumCardManage/NumPool'),
        meta: { title: '号码池', keepAlive: false }
      },
      {
        // 资源-设备管理-MPOS
        path: 'deviceManage/mpos',
        name: 'mpos',
        component: () => import('../../views/Resource/DeviceManage/DeviceMPos'),
        meta: { title: 'MPOS设备', keepAlive: false }
      },
    ]
  }